/**
 * Click-through consent gate for Sarah web voice (Counsel, 2026-10-22).
 *
 * The mic and the xAI session may start only after the visitor taps Start
 * voice on the consent step in this page load. A grant is in memory only and
 * single-use: one tap allows one start. Nothing is remembered across starts,
 * reloads, or sessions, so auto-start, resume, deep links, proactive
 * outreach, or a prior consent can never skip the step.
 */
let pending = false

export class SarahVoiceConsentRequiredError extends Error {
  constructor() {
    super('Sarah voice consent step not accepted')
    this.name = 'SarahVoiceConsentRequiredError'
  }
}

/** Call only from the Start voice button's click handler. */
export function grantSarahVoiceConsent(): void {
  pending = true
}

/** Consumes the grant. True only once per Start voice tap. */
export function takeSarahVoiceConsent(): boolean {
  const ok = pending
  pending = false
  return ok
}

export function clearSarahVoiceConsent(): void {
  pending = false
}

/**
 * After a recording objection: keep structured lead fields only. Drops the
 * free-text fields that hold the visitor's own words.
 */
export function withoutVerbatimAnswers<T extends { question?: string; helpFinding?: string }>(answers: T): T {
  const { question: _q, helpFinding: _h, ...rest } = answers
  void _q
  void _h
  return rest as T
}
